import { render } from "./ViceGlasses.vue?vue&type=template&id=21081a92"
import script from "./ViceGlasses.vue?vue&type=script&lang=js"
export * from "./ViceGlasses.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__